<template>
    <div v-if="backdrop">
        <div class="modal fade" :class="modal.open ? 'show' : ''" style="display: block" tabindex="-1" role="dialog"
            aria-hidden="true" @click="$event.target.classList.contains('modal') ? close() : true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ config.title == null ? '&nbsp;' : config.title }}</h5>
                        <button type="button" class="close" @click="close()" v-html="loading ? spin() : ic('close')" />
                    </div>
                    <form @submit.prevent="submit">
                        <div class="modal-body default">
                            <div class="row">
                                <div class="form-group col-6">
                                    <label for="type" class="form-label">Tipe</label>
                                    <selectize v-model="data.type" data-placeholder="Pilih tipe" id="type" required>
                                        <option :value="t.name" v-for="(t, i) in types" :key="i"> {{ t.text }}</option>
                                    </selectize>
                                </div>
                                <div class="form-group col-6">
                                    <label for="vendor" class="form-label">Vendor</label>
                                    <selectize v-model="data.vendor" data-placeholder="Pilih vendor" id="vendor" required>
                                        <option :value="v.name" v-for="(v, i) in vendors" :key="i"> {{ v.text }}</option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label for="depo" class="form-label">External</label>
                                    <input type="text" class="form-control" placeholder="External" v-model="data.external"
                                        id="depo" required>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label for="twin" class="form-label">Twin</label>
                                    <selectize v-model="data.twin_id" data-placeholder="Pilih data" id="twin" required>
                                        <option :value="tw.id" v-for="(tw, i) in twin" :key="i"> {{ tw.nama }}
                                        </option>
                                    </selectize>
                                    <span>Note: pilih tipe terlebih dahulu</span>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer pt-2">
                            <button type="button" class="btn btn-white" @click="close()" v-html="'Tutup'" />
                            <button type="submit" class="btn btn-primary" :disabled="isSubmit || loading" v-html="isSubmit ? spin() : 'Simpan'" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapState } from "vuex";
export default {
    name: "FormMapping",
    props: {
        config: {
            default: {
                view: false,
                title: "Modal Title"
            }
        },
        initData: null,
        isSubmit: { default: false },
        dismiss: { default: true }
    },

    mixins: [helper],

    data() {
        return {
            backdrop: false,
            modal: {
                open: false,
                formNav: 0
            },

            request: true, 
            types: [
                { name: 'gudang', text: 'Gudang' },
                { name: 'brand', text: 'Brand' },
                { name: 'segmen', text: 'Segmen' },
                { name: 'team', text: 'Team' },
                { name: 'barang', text: 'Barang' },
            ],
            vendors: [
                { name: 'dua_kelinci', text: 'Dua Kelinci' },
            ],
            twin: [],

            data: {
                external: null,
                twin_id: null,
                type: null,
                vendor: null
            },

        };
    },

    computed: {
        ...mapState(['loading'])
    },

    methods: {
        close() {
            this.$emit("update:config", { view: false });
        },
        _getTwin() {
            this.loading = true;
            let url = "external_app/bridging/get_data";
            this.axios.get(url, { params: { type: this.data.type }})
                .then((res) => {
                    this.loading = false;
                    this.twin = res.data.data;
                })
                .catch((err) => {
                    this.loading = false;
                    this.onError(err);
                });
        },
        submit() {
            this.$emit('update:isSubmit', true)
            this.$emit('submit', this.data);
        },

    },

    watch: {
        "config.view": function (view) {
            if (view) {
                this.$emit("update:isSubmit", false);
                this.backdrop = true;
                 setTimeout(() => {
                    this.modal.open = view;
                }, 200);
            } else {
                this.modal.open = view;

                setTimeout(() => {
                    this.backdrop = view;
                }, 100);
            }
        },
        initData: function (data) {
            if (data == null) {
                Object.assign(this.$data.data, this.$options.data.call(this).data);
            } else {
                setTimeout(() => {
                    this._getTwin();
                }, 100);
                for (const key in this.data) {
                    this.data[key] = data[key]
                }
            }
        },
        "data.type": {
            handler: function () {
                this._getTwin();
            },
            deep: true,
        },

    }
};
</script>
